import React, { useEffect, useState } from 'react';
import {
  Box, Button, Text, Heading, Input, useToast, Spinner, Avatar, IconButton,
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody,
  Image, SimpleGrid, Flex
} from '@chakra-ui/react';
import { EditIcon } from '@chakra-ui/icons';
import DeleteIcon from '@mui/icons-material/Delete';
import NavBar from '../components/NavBar';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { motion } from "framer-motion";

import avatar1 from '../images/avatars/avatar1.png';
import avatar2 from '../images/avatars/avatar2.png';
import avatar3 from '../images/avatars/avatar3.png';
import avatar4 from '../images/avatars/avatar4.png';
import avatar5 from '../images/avatars/avatar5.png';
import avatar6 from "../images/avatars/avatar6.png";
import avatar7 from '../images/avatars/avatar7.png';
import avatar8 from '../images/avatars/avatar8.png';
import avatar9 from '../images/avatars/avatar9.png';
import avatar10 from '../images/avatars/avatar10.png';
import avatar11 from '../images/avatars/avatar11.png';
import avatar12 from '../images/avatars/avatar12.png';

const avatarList = [avatar1, avatar2, avatar3, avatar4, avatar5, avatar6, avatar7, avatar8, avatar9, avatar10, avatar11, avatar12];
const avatarFilenames = ['avatar1.png', 'avatar2.png', 'avatar3.png', 'avatar4.png', 'avatar5.png', 'avatar6.png', 'avatar7.png', 'avatar8.png', 'avatar9.png', 'avatar10.png', 'avatar11.png', 'avatar12.png'];

const Profile = () => {
  const [Fname, setFName] = useState('');
  const [Lname, setLName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [resumeData, setResumeData] = useState({});
  const [skills, setSkills] = useState([]);
  const [education, setEducation] = useState([]);
  const [singleSkill, setSingleSkill] = useState('');
  const [edu, setEdu] = useState('');
  const [profilePhoto, setProfilePhoto] = useState(localStorage.getItem('selectedAvatar') || 'avatar1.png');
  const [selectedAvatar, setSelectedAvatar] = useState(profilePhoto);
  const [loading, setLoading] = useState(false);
  const [isAvatarModalOpen, setIsAvatarModalOpen] = useState(false);

  const toast = useToast();
  const { userId, isAdmin } = useSelector((state) => state.user);

  useEffect(() => {
    getUserProfile();
    getUserData();
  }, [userId]);

  const getUserProfile = async () => {
    try {
      const accessToken = window.sessionStorage.getItem('accessToken');
      const { data } = await axios.get(`https://gyanbackend.aim4u.co.in/profile/`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      setFName(data.Fname);
      setLName(data.Lname);
    } catch (error) {
      console.log(error);
    }
  };

  const getUserData = async () => {
    try {
      const accessToken = window.sessionStorage.getItem('accessToken');
      const { data } = await axios.get(`https://gyanbackend.aim4u.co.in/user-data/`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });

      const parsedSkills = JSON.parse(data.skills.replace(/'/g, '"') || '[]');
      const parsedEducation = JSON.parse(data.education.replace(/'/g, '"') || '[]');

      setSkills(parsedSkills);
      setEducation(parsedEducation);
      setPhoneNumber(data.phone_number);
      setResumeData(data);

      const backendAvatar = data.profile_photo || 'avatar1.png';
      const currentLocalAvatar = localStorage.getItem('selectedAvatar');

      setProfilePhoto(currentLocalAvatar || backendAvatar);

      if (!currentLocalAvatar || currentLocalAvatar === backendAvatar) {
        setSelectedAvatar(backendAvatar);
      }

    } catch (error) {
      console.log(error);
    }
  };

  const handleAvatarSelect = (filename) => {
    setSelectedAvatar(filename);
    setIsAvatarModalOpen(false);
  };

  const handleUpdate = async () => {
    if (!Fname && !Lname && !phoneNumber && skills.length === 0 && education.length === 0 && selectedAvatar === profilePhoto) {
      toast({
        title: 'No Changes',
        description: 'Please update at least one field.',
        status: 'info',
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    try {
      setLoading(true);
      const accessToken = window.sessionStorage.getItem('accessToken');

      if (Fname || Lname) {
        await axios.put("https://gyanbackend.aim4u.co.in/profile/", {
          Fname,
          Lname
        }, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json"
          }
        });
      }

      const formData = new FormData();
      formData.append('user', userId);
      if (phoneNumber) formData.append('phone_number', phoneNumber);
      formData.append('skills', JSON.stringify(skills));
      formData.append('education', JSON.stringify(education));
      formData.append('profile_photo', selectedAvatar);

      await axios.put(`https://gyanbackend.aim4u.co.in/user-data/`, formData, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'multipart/form-data',
        },
      });

      toast({
        title: 'Information Updated',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });

      setProfilePhoto(selectedAvatar);
      localStorage.setItem('selectedAvatar', selectedAvatar);

      getUserProfile();
      getUserData();
    } catch (error) {
      toast({
        title: 'Update Failed',
        description: error.response?.data?.detail || 'Something went wrong.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const getAvatarSrc = (filename) => {
    const avatarMap = {
      'avatar1.png': avatar1, 'avatar2.png': avatar2, 'avatar3.png': avatar3, 'avatar4.png': avatar4,
      'avatar5.png': avatar5, 'avatar6.png': avatar6, 'avatar7.png': avatar7, 'avatar8.png': avatar8,
      'avatar9.png': avatar9, 'avatar10.png': avatar10, 'avatar11.png': avatar11, 'avatar12.png': avatar12,
    };
    return avatarMap[filename] || avatar1;
  };

  return (
    <Box
      minH="100vh"
      position="relative"
      bgGradient="linear(to-br, #0c2252, #163a7a, #1e4b9e)"
      overflow="hidden"
    >
      <NavBar isAdmin={isAdmin} />

      {/* Glow Effects */}
      <Box position="absolute" top="20%" left="10%" w="600px" h="600px" bg="blue.500" opacity="0.15" filter="blur(140px)" borderRadius="full" />
      <Box position="absolute" bottom="10%" right="10%" w="500px" h="500px" bg="green.400" opacity="0.12" filter="blur(140px)" borderRadius="full" />

      {loading && (
        <Box position="fixed" zIndex={3} w="full" h="full" display="flex" alignItems="center" justifyContent="center" bg="rgba(0,0,0,0.6)">
          <Spinner size="xl" color="white" />
        </Box>
      )}

      <Flex justify="center" px={4}>
        <motion.div initial={{ opacity: 0, y: 40 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
          <Box
            bg="rgba(255,255,255,0.08)"
            backdropFilter="blur(18px)"
            border="1px solid rgba(255,255,255,0.15)"
            boxShadow="0 30px 80px rgba(0,0,0,.35)"
            borderRadius="2xl"
            p={10}
            mt={14}
            w="100%"
            maxW="640px"
            color="white"
          >
            <Text textAlign="center" fontSize="13px" letterSpacing="3px" textTransform="uppercase" color="whiteAlpha.600">
              Dashboard
            </Text>

            <Heading textAlign="center" fontSize="32px" fontWeight="900" mt={2}>
              Your Profile
            </Heading>

            <Text textAlign="center" fontSize="15px" color="whiteAlpha.700" mt={2} mb={8}>
              Manage your personal information and credentials.
            </Text>

            {/* Avatar */}
            <Box display="flex" justifyContent="center" alignItems="center" position="relative">
              <Avatar size="2xl" src={getAvatarSrc(selectedAvatar)} border="3px solid rgba(255,255,255,0.3)" boxShadow="0 15px 40px rgba(0,0,0,0.4)" />
              <IconButton
                icon={<EditIcon />}
                size="sm"
                position="absolute"
                bottom="10px"
                right="calc(50% - 70px)"
                borderRadius="full"
                bg="whiteAlpha.200"
                color="white"
                _hover={{ bg: 'green.400', transform: 'scale(1.1)' }}
                onClick={() => setIsAvatarModalOpen(true)}
              />
            </Box>

            {/* Inputs */}
            <Input mt={6} placeholder="First Name" value={Fname} onChange={(e) => setFName(e.target.value)}
              bg="whiteAlpha.100" border="1px solid rgba(255,255,255,0.15)"
              _placeholder={{ color: "whiteAlpha.500" }}
              _focus={{ borderColor: "green.400" }} />

            <Input mt={4} placeholder="Last Name" value={Lname} onChange={(e) => setLName(e.target.value)}
              bg="whiteAlpha.100" border="1px solid rgba(255,255,255,0.15)"
              _placeholder={{ color: "whiteAlpha.500" }}
              _focus={{ borderColor: "green.400" }} />

            <Input mt={4} placeholder="Phone Number" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)}
              bg="whiteAlpha.100" border="1px solid rgba(255,255,255,0.15)"
              _placeholder={{ color: "whiteAlpha.500" }}
              _focus={{ borderColor: "green.400" }} />

            {/* Skills */}
            <Heading size="md" mt={8}>Skills</Heading>
            <Flex wrap="wrap" gap={2} mt={3}>
              {skills.map((skill, index) => (
                <Box key={index} bg="green.500" px={4} py={1.5} borderRadius="full" display="flex" alignItems="center">
                  <Text fontSize="13px">{skill}</Text>
                  <DeleteIcon style={{ marginLeft: 8, cursor: 'pointer' }} onClick={() => setSkills(skills.filter((_, i) => i !== index))} />
                </Box>
              ))}
            </Flex>

            <Flex gap={3} mt={4}>
              <Input placeholder="Add skill" value={singleSkill} onChange={(e) => setSingleSkill(e.target.value)}
                bg="whiteAlpha.100" border="1px solid rgba(175, 245, 202, 0.6)" />
              <Button bgGradient="linear(to-r, green.400, green.600)" color="white"
                onClick={() => {
                  if (singleSkill.trim()) {
                    setSkills([...skills, singleSkill.trim()]);
                    setSingleSkill('');
                  }
                }}>
                Add
              </Button>
            </Flex>

            {/* Education */}
            <Heading size="md" mt={8}>Education</Heading>
            <Flex wrap="wrap" gap={2} mt={3}>
              {education.map((eduItem, index) => (
                <Box key={index} bg="blue.500" px={4} py={1.5} borderRadius="full" display="flex" alignItems="center">
                  <Text fontSize="13px">{eduItem}</Text>
                  <DeleteIcon style={{ marginLeft: 8, cursor: 'pointer' }} onClick={() => setEducation(education.filter((_, i) => i !== index))} />
                </Box>
              ))}
            </Flex>

            <Flex gap={3} mt={4}>
              <Input placeholder="Add education" value={edu} onChange={(e) => setEdu(e.target.value)}
                bg="whiteAlpha.100" border="1px solid rgba(255,255,255,0.15)" />
              <Button bgGradient="linear(to-r, green.400, green.600)" color="white"
                onClick={() => {
                  if (edu.trim()) {
                    setEducation([...education, edu.trim()]);
                    setEdu('');
                  }
                }}>
                Add
              </Button>
            </Flex>

            <Button
              mt={10}
              w="full"
              size="lg"
              fontWeight="bold"
              color="white"
              bgGradient="linear(to-r, green.400, green.600)"
              boxShadow="0 20px 50px rgba(16,185,129,.4)"
              _hover={{ transform: "translateY(-3px)" }}
              onClick={handleUpdate}
            >
              Save Changes
            </Button>
          </Box>
        </motion.div>
      </Flex>
    </Box>
  );
};

export default Profile;
